import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  resultCardWrapper: {
    fontFamily: Theme.typography.base.regular,
    backgroundColor: Theme.palette.white,
    borderRadius: '5px',
    marginTop: '20px',
    minHeight: '100px',
    boxShadow: '0px 2px 4px 0 rgba(6,21,86,0.15)',
    [Theme.breakpoints.down('lg')]: {
      minHeight: '136px',
    },
    [Theme.breakpoints.down('md')]: {
      minHeight: '100px',
    },
    [Theme.breakpoints.down('sm')]: {
      minHeight: '132px',
    },
  },
  resultCard: {
    display: 'flex',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: '0',
    minHeight: 100,
    '&:last-child': {
      paddingBottom: '0',
    },
    '&:hover': {
      cursor: 'pointer',
    },
    [Theme.breakpoints.down('sm')]: {
      minHeight: 'auto',
    },
  },
  cardInfo: {
    position: 'relative',
    margin: '25px auto',
    textAlign: 'left',
    '& > p': {
      margin: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      margin: '30px auto',
      marginBottom: '20px',
    },
    [Theme.breakpoints.down('md')]: {
      margin: '25px auto',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '30px auto',
    },
  },
  pricingInfo: {
    display: 'flex',
    marginRight: '41px',
    textAlign: 'right',
    alignItems: 'center',
    [Theme.breakpoints.down('lg')]: {
      marginRight: '36px',
      alignItems: 'unset',
    },
    [Theme.breakpoints.down('md')]: {
      marginRight: '26px',
      alignItems: 'center',
    },
    [Theme.breakpoints.down('sm')]: {
      marginRight: '20px',
      alignItems: 'unset',
      marginBottom: 20,
    },
  },
  flightPricing: {
    display: 'inline-block',
    '& > p': {
      margin: '0',
    },
  },
  standardLabel: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    lineHeight: '150%',
    color: Theme.palette.gray[750],
  },
  smallLabel: {
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    color: Theme.palette.gray[500],
  },
  flightPrice: {
    color: Theme.palette.primary.main,
    whiteSpace: 'pre',
  },
  flightPriceUnit: {
    color: Theme.palette.primary.main,
  },
  flightWasPrice: {
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    textAlign: 'right',
    color: Theme.palette.gray[500],
    marginTop: '5px !important',
    whiteSpace: 'pre',
  },
  expandFlightDetails: {
    alignSelf: 'center',
    marginLeft: '10px',
    color: Theme.palette.primary.light,
    position: 'relative',
    [Theme.breakpoints.down('lg')]: {
      alignSelf: 'flex-start',
    },
    [Theme.breakpoints.down('md')]: {
      alignSelf: 'center',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: Theme.transitions.create('transform', {
      duration: Theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  typeSmall: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  typeMedium: {
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  layoverDays: {
    fontSize: 'smaller',
    position: 'relative',
    top: '-5px',
  },
  overridePagination: {
    '& button': {
      color: Theme.palette.primary.light,
    },
    color: Theme.palette.gray[750],
    '&.MuiTablePagination-root': {
      marginTop: '30px',
      marginBottom: '20px',
    },
    '& button:last-child': {
      paddingRight: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      '&.MuiTablePagination-root': {
        marginBottom: '10px',
      },
    },
    [Theme.breakpoints.down('md')]: {
      '&.MuiTablePagination-root': {
        marginBottom: '30px',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      '&.MuiTablePagination-root': {
        marginTop: '20px',
      },
    },
  },
}));

export default useStyles;
